import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OnboardingPage from './pages/OnboardingPage';

const App: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/form" element={<OnboardingPage />} />
        <Route path="/" element={<Navigate to="/form" replace />} />
        <Route
          path="*"
          element={
            <div className="min-h-screen flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                <p className="text-gray-600">{t('errors.pageNotFound')}</p>
              </div>
            </div>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
